import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { PortfolioRemindersSectionContent } from "web_myplann/Reminders/Components/PortfolioRemindersSectionContent";
import { PropertyRemindersSectionContent } from "web_myplann/Reminders/Components/PropertyRemindersSectionContent";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
};

export const RemindersSectionContent = ({ entity }: Props) =>
	entity.type === ReminderEntityTypeEnum.Portfolio ? (
		<PortfolioRemindersSectionContent entity={entity} />
	) : (
		<PropertyRemindersSectionContent entity={entity} />
	);
